export const FETCH_APPLIED_JOBS_LIST_REQUEST = 'FETCH_APPLIED_JOBS_LIST_REQUEST'
export const FETCH_APPLIED_JOBS_LIST_SUCCESS = 'FETCH_APPLIED_JOBS_LIST_SUCCESS'
export const FETCH_APPLIED_JOBS_LIST_FAILED = 'FETCH_APPLIED_JOBS_LIST_FAILED'
export const CLEAR_FETCH_APPLIED_JOBS_LIST = 'CLEAR_FETCH_APPLIED_JOBS_LIST'
